<template>
  <b-form-group :label="$t(label)">
    <b-form-input :id="id"
                  v-model="value"
                  :input="inputValue()"
                  :state="state"
                  @keypress="isNumber($event)"
                  :placeholder="$t(placeholder?placeholder:label)"></b-form-input>

    <!-- @keyup="controlMinMax($event)" -->
  </b-form-group>
</template>

<script>
export default {
  props: {
    label: String,
    id: String,
    state: Boolean,
    placeholder: String,
    defaultValue: { type: String, default: '' },
    // min: {
    //   type: Number | String,
    //   default: -1,
    // },
    // max: {
    //   type: Number | String,
    //   default: -1,
    // },
  },
  name: 'NumberInput',
  data() {
    return {
      value: '',
    }
  },
  created() {
    this.setValue()
  },
  methods: {
    setValue() {
      this.value = this.defaultValue != '' ? this.defaultValue : ''
    },
    inputValue() {
      this.$emit('input', this.value)
    },
    isNumber(evt) {
      evt = evt ? evt : window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    controlMinMax(evt) {
      if (this.max != -1 && parseFloat(this.value) >= this.max)
        this.value = this.max

      if (this.min != -1 && parseFloat(this.value) < this.min)
        this.value = this.min
    },
  },
  watch: {
    defaultValue(val) {
      this.setValue()
    },
  },
}
</script>